import styled from 'styled-components';
import {
  WHITE,
  SEA_FOAM,
  CHARCOAL,
  DARK_SKY,
  MOBILE
} from '../../theme';

const NewsletterPreviewContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  color: ${WHITE};
  font-family: Roboto, sans-serif;
`;

const Banner = styled.div`
  width: 100%;
  padding: 2rem 0;
  background: ${SEA_FOAM};
  display: grid;
  place-items: center;

  p {
    color: ${DARK_SKY};
    margin: 0rem 1rem;
    font-weight: 600;
    text-align: center;
    line-height: 31px;
  }
`;

const NewsletterSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${CHARCOAL};
`;

const NewsletterSectionContent = styled.div`
  width: ${MOBILE};
  @media(max-width: ${MOBILE}){
    width: 90%;
  }
`;

const NewsletterMeta = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 0;

  p {
    margin: 0.5rem 0;
    span {
      font-weight: bold;
    }
  }
`;

const BrandContainer = styled.div`
  display: flex;
  align-items: center;
  height: 2rem;
  margin-top: 1rem;
  
  img {
    height: 100%;
    width: auto;
  }

  p {
    margin: 0 0 0 0.5rem;
    font-weight: bold;
    font-size: 1rem;
  }
`;

export {
  NewsletterPreviewContainer,
  Banner,
  NewsletterSectionContent,
  NewsletterSection,
  NewsletterMeta,
  BrandContainer,
} 